<template>
    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :rules="ruleValidate" :label-width="85" label-position="right"
                                  :loading="loading" ref="form">
                                <FormItem :label="t.dept.name" prop="name">
                                    <Input v-model.trim="formItem.name" :maxlength="32"
                                           :placeholder="msgUtil.placeholderRequired(t.dept.name)"></Input>
                                </FormItem>
                                <FormItem :label="t.dept.leader" prop="leader">
                                    <Input v-model.trim="formItem.leader" :maxlength="32"
                                           :placeholder="msgUtil.placeholderRequired(t.dept.leader)"></Input>
                                </FormItem>
                                <FormItem :label="t.dept.mobile" prop="mobile">
                                    <Input v-model.trim="formItem.mobile" :maxlength="15"
                                           :placeholder="msgUtil.placeholderRequired(t.dept.mobile)"></Input>
                                </FormItem>
                                <FormItem :label="t.dept.email" prop="email">
                                    <Input v-model.trim="formItem.email" :maxlength="70"
                                           :placeholder="msgUtil.placeholderRequired(t.dept.email)"></Input>
                                </FormItem>
                                <FormItem :label="t.dept.sortOrder" prop="sortOrder">
                                    <InputNumber v-model.trim="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.dept.status" prop="status">
                                    <i-switch v-model.trim="formItem.status" size="large" true-value="1" false-value="0">
                                        <span slot="open">{{t.dept.open}}</span>
                                        <span slot="close">{{t.dept.close}}</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" :loading="loading" @click="handleSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()" style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>
<script>
import { add } from '@/api/dept';

export default {
    name: 'organization_dept_add',
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItem: {
                name: '',
                leader: '',
                status: '1',
                mobile: '',
                email: '',
                sortOrder: 0,
            },
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dept.name),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 32,
                        message: msgUtil.errorMaxLengthFullWidth(t.dept.name, 32),
                        trigger: 'blur',
                    },
                ],
                leader: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dept.leader),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 32,
                        message: msgUtil.errorMaxLengthFullWidth(t.dept.leader, 32),
                        trigger: 'blur',
                    },
                ],
                mobile: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dept.mobile),
                        trigger: 'blur',
                    },
                    {
                        pattern: /^[0-9]*$/,
                        message: msgUtil.errorRequiredHalfWidthNumber(t.dept.mobile),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 15,
                        message: msgUtil.errorMaxLength(t.dept.mobile, 15),
                        trigger: 'blur',
                    },
                ],
                email: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.dept.email),
                        trigger: 'blur',
                    },
                    {
                        type: 'email',
                        message: msgUtil.errorFormat(t.dept.email),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 70,
                        message: msgUtil.errorMaxLength(t.dept.email, 70),
                        trigger: 'blur',
                    },
                ],
            },
            loading: false,
        };
    },
    methods: {
        handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            this.$refs['form'].validate(async valid => {
                if (valid) {
                    this.loading = true;
                    const res = await add(this.formItem);
                    this.$Message.success(this.msgUtil.message.action.addSuccess);
                    this.$refs.form.resetFields();
                    this.$Loading.finish();
                } else {
                    this.$Loading.error();
                    this.$Message.error(this.msgUtil.message.action.addFail);
                }
            });
            this.loading = false;
        },
        handleReset() {
            this.$refs.form.resetFields();
            this.loading = false;
        },
    },
};
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
